import {
  type ChatThreadRow,
  chatArrivedAfterClosure,
  chatMinute,
  chatStampsDiverge,
} from '@/lib/chat-transcript';

interface ChatMessageStampsProps {
  row: ChatThreadRow;
  closedAt: string | null;
}

/**
 * The hour under a bubble - one, two, or a sentence.
 *
 * The three cases are the three things §8.2 asks a reader to be able to see:
 * when it landed; that it was written earlier than it landed, and how much
 * earlier; and that it has not landed at all yet.
 */
export function ChatMessageStamps({ row, closedAt }: ChatMessageStampsProps) {
  if (row.kind === 'pending') {
    return (
      <span className="font-semibold text-gray-600 text-micro" data-testid="chat-pending-stamp">
        En attente d'envoi, composé à {chatMinute(row.message.composedAt)}
      </span>
    );
  }

  const { message } = row;
  const late = chatArrivedAfterClosure(message, closedAt);
  // Both hours when they diverge, and ALWAYS both on a message that arrived
  // after the closure: that one's whole meaning is the gap between the two.
  if (chatStampsDiverge(message) || late) {
    return (
      <span className="text-gray-500 text-micro" data-testid="chat-two-stamps">
        {late ? 'Arrivé après la clôture à ' : 'Arrivé à '}
        {chatMinute(message.receivedAt)}, composé à {chatMinute(message.composedAt)}
      </span>
    );
  }

  return (
    <span className="text-gray-500 text-micro" data-testid="chat-stamp">
      {chatMinute(message.receivedAt)}
    </span>
  );
}
